// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Gets or sets the Address.
*/
export class EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberAddressModel {
    /**
    * @description Gets or sets the address line1.
    */
    'address1'?: string | null;
    /**
    * @description Gets or sets the  address line2.
    */
    'address2'?: string | null;
    /**
    * @description Gets or sets the city.
    */
    'city'?: string | null;
    /**
    * @description Gets or sets the Postal code.
    */
    'zipCode'?: string | null;
    /**
    * @description Gets or sets the state.
    */
    'state'?: string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberAddressModel>> = [
        {
            "name":     "address1",
            "baseName": "address1",
            "type":     "string"
        },
        {
            "name":     "address2",
            "baseName": "address2",
            "type":     "string"
        },
        {
            "name":     "city",
            "baseName": "city",
            "type":     "string"
        },
        {
            "name":     "zipCode",
            "baseName": "zipCode",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return EServicesOrchestratorServicePublicNewPathModelsMedicalCardFinderPrescriberAddressModel.attributeTypeMap;
    }
}
